/**
 * Fase 1 Referral V2: identidad desde la sesión actual de la app.
 * Sin JWT. El backend resolverá iderp a partir de id LMS en la fase 2.
 */

export function sesionReferralDesdeGetters({
  logeado,
  usuario,
  datosUsuario,
  escuela,
} = {}) {
  if (!logeado || !usuario) {
    return { ok: false, motivo: 'SIN_SESION' }
  }

  const roll = usuario.roll ? String(usuario.roll).toUpperCase() : ''
  if (roll && roll !== 'ALUMNO') {
    return { ok: false, motivo: 'NO_ALUMNO' }
  }

  if (!datosUsuario) {
    return { ok: false, motivo: 'SIN_DATOS_GENERALES' }
  }

  if (usuario.id == null || usuario.id === '') {
    return { ok: false, motivo: 'SIN_ID_LMS' }
  }

  const brandId = Number(escuela) === 2 ? 2 : 1

  return {
    ok: true,
    motivo: null,
    idLms: usuario.id,
    brandId,
  }
}
